import { ArrowLeft } from '@App/static/icons/DashboardIcons'
import s from './styles.module.scss'
import { useState } from 'react'
import cn from 'clsx'
import OutsideClickComponent from '@App/ui/crypto_exchange/desktop/components/common/OutsideClickHandler'
import { CheckIcon } from '@App/static/icons/FooterIcons'
import { Checkbox } from '../Checkbox'

export const MultiSelect = <T,>({
  onChange,
  value,
  placeholder,
  options,
  containerClassName,
  inputClassName,
  optionsClassName,
  label,
}: {
  value?: T[] | null
  options: { name: string; subname?: string; value: T; separated?: boolean }[]
  onChange?: (value: T[]) => void
  placeholder?: string
  label?: string
  containerClassName?: string
  inputClassName?: string
  optionsClassName?: string
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const onSelect = (val: T) => {
    if (val === 'all') {
      const allSelected = value?.some((v) => v === 'all')
      if (allSelected) {
        onChange?.([])
        return
      }
      onChange?.(options.map((v) => v.value))
      return
    }
    if (!value) {
      onChange?.([val])
      return
    }

    const index = value.indexOf(val)

    if (index === -1) {
      onChange?.([...value, val])
      return
    }

    const newValue = value.filter((v) => v !== val && v !== 'all')
    onChange?.(newValue)
  }
  return (
    <OutsideClickComponent className={cn(s.container, containerClassName)} handler={() => setIsOpen(false)}>
      {label && <span className={s.label}>{label}</span>}
      <div
        className={cn(s.select, isOpen && s.active, label && s.withLabel, inputClassName)}
        onClick={() => setIsOpen(!isOpen)}
      >
        {placeholder} {value?.length !== options.length && <span className={s.counter}>{value?.length}</span>}
      </div>
      <ArrowLeft className={cn(s.arrowIcon, isOpen ? s.open : s.close)} />
      {isOpen && (
        <ul className={cn(s.options, optionsClassName)}>
          {options.map((option) => (
            <li
              key={option.name}
              className={cn(s.option, option.subname && s.withSubName, option.separated && s.separated)}
              onClick={() => onSelect(option.value)}
            >
              <div className={s.nameContainer}>
                <Checkbox name={`check_${option.name}`} label={''} checked={value?.some((v) => v === option.value)} />{' '}
                <span className={s.name}>{option.name}</span>
                {option.subname && <span className={s.subname}>{option.subname}</span>}
              </div>
            </li>
          ))}
        </ul>
      )}
    </OutsideClickComponent>
  )
}
